var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hotel-type" },
    [
      _vm.rate
        ? [
            _c(
              "div",
              { staticClass: "icons" },
              _vm._l(_vm.hotelTypes, function (type, index) {
                return _c("div", {
                  key: type.id,
                  staticClass: "point",
                  class: { active: _vm.position >= index },
                })
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "name" },
              [_vm._v(" " + _vm._s(_vm.match.name)), _vm._t("default")],
              2
            ),
          ]
        : _c(
            "div",
            { staticClass: "name" },
            [_vm._v(" Hotel Property"), _vm._t("default")],
            2
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }